import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import Email from "./ModalEmail";

const ActionItem = (
  { teamAction, deleteTeamAction, updateTeamAction },
  ref
) => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState("");
  const [isOpenEmail, setOpenEmail] = useState(false);
  const header_text = window.team_action.team_action_header_text;
  const navigate = useNavigate();
  const useWp = window.end_page.end_send_email_via_wp;

  const handleChange = e => {
    e.preventDefault();
    setTitle(e.target.value);
  };

  const handleSubmit = () => {
    if (title.trim().length !== 0) {
      updateTeamAction(title);
      setTitle("");
    } else {
      alert("please enter the text before adding team action");
    }
  };

  const handleEmail = () => {
    const email = "";
    const title = window.end_page.end_page_title;
    const subject = encodeURIComponent(window.end_page.end_page_email_subject);
    const message = window.end_page.end_page_email_body;

    const body = `${message}\n\n${teamAction
      .map(action => `- ${action}\n\n`)
      .join("")}`;

    window.open(`https://mail.google.com/mail/?view=cm&to=${email}&su=${subject}&body=${encodeURIComponent(
      body
    )}`, '_blank');
  };

  const openEmailPopup = () => {
    setOpenEmail(true);
  };

  const closeEmailPopup = () => {
    setOpenEmail(false);
  };

  useEffect(() => {
    const data = () => {
      setItems(teamAction);
    };

    data();
  }, [teamAction]);

  const font_heading = window.fonts.heading.regular_font;
  const font_body = window.fonts.body.regular_font;

  const addActionText = window.end_page.end_custom_team_action_add_button;

  const popUpSendEmailText = window.end_page.end_send_email_end_button;

  const inputTitle = window.end_page.end_page_team_action_input_title;
  const inputPlaceholder =
    window.end_page.end_page_team_action_input_placeholder;
  return (
    <>
      <div className="action-wrapper">
        <div className="input-wrapper">
          <span className="input-title">{inputTitle}</span>
          <form className="input-action">
            <textarea
              type="text"
              className="action-input"
              value={title}
              placeholder={inputPlaceholder}
              onChange={handleChange}
            />
            <button
              className="action-button"
              type="button"
              onClick={handleSubmit}
            >
              <FontAwesomeIcon icon={faPlus} />
              {addActionText}
            </button>
          </form>
        </div>
        <span className="action-title">{header_text}</span>
        <ul className="action">
          {items.map((item, index) => {
  
            const primaryColor = window.themes.font_color;
            const textColor = window.themes.primary_color;
            const isInvert = primaryColor === textColor ? "action-item inverted" : "action-item default";
            return (
              <li className={isInvert} key={index}>
                <div className="content-text">
                  <FontAwesomeIcon icon={faCircle} className="circle-icon" />
                  <span>{item}</span>
                </div>
                <button
                  className="delete-action"
                  onClick={() => deleteTeamAction(item)}
                  title="Delete"
                >
                  <FontAwesomeIcon className="trash-icon" icon={faTrash} />
                </button>
              </li>
            );
          })}
        </ul>
        <div className="btn-action-container">
          <Button
            className="btn-action"
            iconPosition="start"
            color="white"
            background={
              window.themes?.secondary_use_single_color
                ? window.themes.secondary_color
                : `linear-gradient(${
                    window.themes?.secondary_color_gradient?.direction
                  }, ${
                    window.themes?.secondary_color_gradient?.gradient_colors[0]
                      ?.color
                  } 0%, ${
                    window.themes?.secondary_color_gradient?.gradient_colors[1]
                      ?.color
                  } 100%)`
            }
            text={
              window.end_page.end_send_email_button
                ? window.end_page.end_send_email_button
                : t("Send Email")
            }
            // onClick={() => handleEmail()}
            // onClick={() => openEmailPopup()}
            onClick={useWp ? openEmailPopup : handleEmail}
          />
          <Button
            onClick={() => navigate(-1)}
            className="btn-action"
            iconPosition="start"
            color="white"
            background={
              window.themes?.primary_use_single_color
                ? window.themes.primary_color
                : `linear-gradient(${
                    window.themes?.primary_color_gradient?.direction
                  }, ${
                    window.themes?.primary_color_gradient?.gradient_colors[0]
                      ?.color
                  } 0%, ${
                    window.themes?.primary_color_gradient?.gradient_colors[1]
                      ?.color
                  } 100%)`
            }
            text={
              window.end_page.end_play_again_button
                ? window.end_page.end_play_again_button
                : t("Play Again")
            }
          />
        </div>
      </div>
      <Email
        isOpen={isOpenEmail}
        onClose={closeEmailPopup}
        emailButton={{
          text: popUpSendEmailText,
          color: window.button_color.text_login_color,
          background: window.themes.primary_color
        }}
        teamAction={teamAction}
      />
    </>
  );
};

export default ActionItem;
